<template>
  <ShopifyPicking v-if="SHOPIFYBRANDS.includes(BRAND)"></ShopifyPicking>
  <OpenCartPicking v-else></OpenCartPicking>
</template>

<script>
import { ShopifyPicking, OpenCartPicking } from "./partials";
export default {
  name: "picking",
  components: {
    ShopifyPicking,
    OpenCartPicking
  }
};
</script>
